import { LoginTypes } from './actionTypes';

const initialState = {
  error: '',
  loading: false,
  currentPswStatus: '',
};

const login = (state = initialState, action: any) => {
  switch (action.type) {
    case LoginTypes.LOGIN_USER:
      state = {
        ...state,
        loading: true,
      };
      break;
    case LoginTypes.LOGIN_INVALID:
      state = {
        ...state,
        loading: false,
      };
      break;
    case LoginTypes.LOGIN_SUCCESS:
      state = {
        ...state,
        loading: false,
      };
      break;
    case LoginTypes.LOGOUT_USER:
      state = { ...state };
      break;
    case LoginTypes.LOGOUT_USER_SUCCESS:
      state = { ...state };
      break;
    case LoginTypes.API_ERROR:
      state = { ...state, error: action.payload, loading: false };
      break;

    case LoginTypes.RESET_PASSWORD:
      state = {
        ...state,
        loading: true,
      };
      break;
    case LoginTypes.RESSET_PASSWORD_SUCCESS:
      state = {
        ...state,
        loading: false,
        currentPswStatus: action.payload.status,
      };
      break;
    case LoginTypes.RESSET_PASSWORD_FAIL:
      state = {
        ...state,
        loading: false,
        currentPswStatus: action.payload.status,
      };
      break;
    case LoginTypes.RESET_STATUS:
      state = {
        ...state,
        loading: false,
        currentPswStatus: '',
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default login;
